import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { AppThunk } from "./store";
import { setAllStates } from "./Loading_Slice";
import { setType, viewType, setCursors, setSortField, setSortOrder, sortFieldType, sortType, cursorsType } from "./View_Slice";
import { toastListProp, toastType, createToastProperties } from '../components/toast/Toast';
import { addToQueue } from "./Toasts_Slice";
import { batch } from 'react-redux';
import logger from "../logger";
import CONSTANTS from "../constants";

// Simplified: No searchMode needed - search always shows all results (no calendar date filter)
// Date interval picker provides optional date filtering

type searchState = {
    freeTextSearch: string;
    searchInProgress: boolean; // Blocks Query.tsx during coordinated search
    // operator: string  /* === AND/OR OPERATOR FEATURE - COMMENTED OUT === */
}

let initialState: searchState = {
    freeTextSearch: "",
    searchInProgress: false,
    // operator: CONSTANTS.DEFAULT_OPERATOR_TO_USE,  /* === AND/OR OPERATOR FEATURE - COMMENTED OUT === */
};


const searchSlice = createSlice({
    name: 'Search',
    initialState: initialState,
    reducers: {
        setFreeTextSearch(state, action: PayloadAction<string>) {
            state.freeTextSearch=action.payload
        },
        setSearchInProgress(state, action: PayloadAction<boolean>) {
            state.searchInProgress=action.payload
        },
        /* === AND/OR OPERATOR FEATURE - COMMENTED OUT === */
        // setOperator(state, action: PayloadAction<string>) {
        //     state.operator=action.payload
        // },
        /* === END AND/OR OPERATOR FEATURE === */
    }
});

//
// Simplified coordinated search - no date navigation, just execute search
// This thunk prevents multiple queries by coordinating all state updates
//
export const executeSearchWithNavigation = (criteria: string): AppThunk => (dispatch, getState) => {
    batch(() => {
        // Block Query.tsx from firing during our coordinated updates
        dispatch(setSearchInProgress(true));

        try {
            // Update view state for search
            dispatch(setType(viewType.List));

            const cursorInfo: cursorsType = {
                cursorStart: 0,
                cursorRows: CONSTANTS.UI.ITEM_PER_PAGE_CHOICES[0]
            };
            dispatch(setCursors(cursorInfo));

            dispatch(setSortField(sortFieldType.date));
            dispatch(setSortOrder(sortType.descending));

            dispatch(setFreeTextSearch(criteria));

        } catch (error) {
            logger.error("Search error: " + error);
            const errorMessage = error instanceof Error ? error.message : String(error);
            dispatch(setAllStates({loading: false, ok: false, error: errorMessage}));
            const toastProperties: toastListProp = createToastProperties(toastType.error, "Search error", errorMessage);
            dispatch(addToQueue(toastProperties));
        } finally {
            // Always unblock Query.tsx
            dispatch(setSearchInProgress(false));
        }
    });
};


export const {setFreeTextSearch, setSearchInProgress /*, setOperator*/} = searchSlice.actions;  /* === AND/OR OPERATOR FEATURE - COMMENTED OUT === */

export default searchSlice.reducer